"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOwnedTokenAccount = exports.useTokenContext = exports.TokenContextProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var web3_js_1 = require("@solana/web3.js");
var usehooks_ts_1 = require("usehooks-ts");
var pubkeys_1 = require("../utils/pubkeys");
var userTokens_1 = require("../utils/userTokens");
var _TokenContext = react_1.default.createContext(null);
/**
 * Provider for user token balances
 * Token balances are polled at fixed intervals
 * @returns
 */
function TokenContextProvider(_a) {
    var _this = this;
    var provider = _a.provider, children = _a.children;
    var _b = (0, react_1.useState)(), userTokens = _b[0], setUserTokens = _b[1];
    var poll = provider.wallet.publicKey && provider.connection;
    var pollDuration = poll ? 10000 : null;
    if (poll && !userTokens && userTokens !== "fetching") {
        pollDuration = 0;
    }
    // Poll for user tokens from Solscan
    (0, usehooks_ts_1.useInterval)(function () { return __awaiter(_this, void 0, void 0, function () {
        var fetchedTokens, lamportsBal, _a, _b, error_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 4, , 5]);
                    if (!userTokens) {
                        setUserTokens("fetching");
                    }
                    return [4 /*yield*/, (0, userTokens_1.fetchUserTokens)(provider.wallet.publicKey.toString())];
                case 1:
                    fetchedTokens = _d.sent();
                    return [4 /*yield*/, provider.connection.getBalance(provider.wallet.publicKey)];
                case 2:
                    lamportsBal = _d.sent();
                    _a = fetchedTokens;
                    _b = pubkeys_1.SOL_MINT.toString();
                    _c = {
                        tokenAccount: "",
                        tokenSymbol: "SOL",
                        tokenAmount: lamportsBal / web3_js_1.LAMPORTS_PER_SOL
                    };
                    return [4 /*yield*/, (0, userTokens_1.fetchSolPrice)()];
                case 3:
                    _a[_b] = (_c.priceUsdt = _d.sent(),
                        _c);
                    setUserTokens(fetchedTokens);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _d.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, pollDuration);
    return ((0, jsx_runtime_1.jsx)(_TokenContext.Provider, __assign({ value: {
            provider: provider,
            userTokens: userTokens,
        } }, { children: children }), void 0));
}
exports.TokenContextProvider = TokenContextProvider;
function useTokenContext() {
    var ctx = (0, react_1.useContext)(_TokenContext);
    if (ctx === null) {
        throw new Error("Context not available");
    }
    return ctx;
}
exports.useTokenContext = useTokenContext;
/**
 * Hook to return token balance of user for given mint
 * @param mint
 * @returns
 */
// Null => none exists.
// Undefined => loading.
function useOwnedTokenAccount(mint) {
    var userTokens = useTokenContext().userTokens;
    // Loading
    if (mint === undefined || userTokens === "fetching") {
        return undefined;
    }
    var isSol = mint === null || mint === void 0 ? void 0 : mint.equals(pubkeys_1.SOL_MINT);
    var tokenAccount = userTokens === null || userTokens === void 0 ? void 0 : userTokens[mint.toString()];
    // Account for given mint does not exist
    if (!isSol && !tokenAccount) {
        return null;
    }
    return tokenAccount;
}
exports.useOwnedTokenAccount = useOwnedTokenAccount;
